 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_TITLE from '@/components/xhtml/01_Title'
 import XHTML02_DEDICATION from '@/components/xhtml/02_Dedication'
 import XHTML03_FM01 from '@/components/xhtml/03_Fm01'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML04_FOREWORD from '@/components/xhtml/04_Foreword'
 import XHTML05_PROLOGUE from '@/components/xhtml/05_Prologue'
 import XHTML06_PART01 from '@/components/xhtml/06_Part01'
 import XHTML07_CHAPTER01 from '@/components/xhtml/07_Chapter01'
 import XHTML08_CHAPTER02 from '@/components/xhtml/08_Chapter02'
 import XHTML09_CHAPTER03 from '@/components/xhtml/09_Chapter03'
 import XHTML10_CHAPTER04 from '@/components/xhtml/10_Chapter04'
 import XHTML11_CHAPTER05 from '@/components/xhtml/11_Chapter05'
 import XHTML12_CHAPTER06 from '@/components/xhtml/12_Chapter06'
 import XHTML13_PART02 from '@/components/xhtml/13_Part02'
 import XHTML14_CHAPTER01 from '@/components/xhtml/14_Chapter01'
 import XHTML15_CHAPTER02 from '@/components/xhtml/15_Chapter02'
 import XHTML16_CHAPTER03 from '@/components/xhtml/16_Chapter03'
 import XHTML17_CHAPTER04 from '@/components/xhtml/17_Chapter04'
 import XHTML18_CHAPTER05 from '@/components/xhtml/18_Chapter05'
 import XHTML19_CHAPTER06 from '@/components/xhtml/19_Chapter06'
 import XHTML20_CHAPTER07 from '@/components/xhtml/20_Chapter07'
 import XHTML21_CHAPTER08 from '@/components/xhtml/21_Chapter08'
 import XHTML22_CHAPTER09 from '@/components/xhtml/22_Chapter09'
 import XHTML23_CHAPTER10 from '@/components/xhtml/23_Chapter10'
 import XHTML24_CHAPTER11 from '@/components/xhtml/24_Chapter11'
 import XHTML25_CHAPTER12 from '@/components/xhtml/25_Chapter12'
 import XHTML26_CHAPTER13 from '@/components/xhtml/26_Chapter13'
 import XHTML27_CHAPTER14 from '@/components/xhtml/27_Chapter14'
 import XHTML28_CHAPTER15 from '@/components/xhtml/28_Chapter15'
 import XHTML29_CHAPTER16 from '@/components/xhtml/29_Chapter16'
 import XHTML30_CHAPTER17 from '@/components/xhtml/30_Chapter17'
 import XHTML31_CHAPTER18 from '@/components/xhtml/31_Chapter18'
 import XHTML32_CHAPTER19 from '@/components/xhtml/32_Chapter19'
 import XHTML33_CHAPTER20 from '@/components/xhtml/33_Chapter20'
 import XHTML34_CHAPTER21 from '@/components/xhtml/34_Chapter21'
 import XHTML35_CHAPTER22 from '@/components/xhtml/35_Chapter22'
 import XHTML36_CHAPTER23 from '@/components/xhtml/36_Chapter23'
 import XHTML37_CHAPTER24 from '@/components/xhtml/37_Chapter24'
 import XHTML38_CHAPTER25 from '@/components/xhtml/38_Chapter25'
 import XHTML39_CHAPTER26 from '@/components/xhtml/39_Chapter26'
 import XHTML40_CHAPTER27 from '@/components/xhtml/40_Chapter27'
 import XHTML41_CHAPTER28 from '@/components/xhtml/41_Chapter28'
 import XHTML42_CHAPTER29 from '@/components/xhtml/42_Chapter29'
 import XHTML43_PART03 from '@/components/xhtml/43_Part03'
 import XHTML44_CHAPTER01 from '@/components/xhtml/44_Chapter01'
 import XHTML45_CHAPTER02 from '@/components/xhtml/45_Chapter02'
 import XHTML46_CHAPTER03 from '@/components/xhtml/46_Chapter03'
 import XHTML47_CHAPTER04 from '@/components/xhtml/47_Chapter04'
 import XHTML48_CHAPTER05 from '@/components/xhtml/48_Chapter05'
 import XHTML49_PART04 from '@/components/xhtml/49_Part04'
 import XHTML50_CHAPTER01 from '@/components/xhtml/50_Chapter01'
 import XHTML51_CHAPTER02 from '@/components/xhtml/51_Chapter02'
 import XHTML52_PART05 from '@/components/xhtml/52_Part05'
 import XHTML53_SOME_RISK_FACTORS from '@/components/xhtml/53_Some_Risk_Factors'
 import XHTML54_CIRCUMSTANCES from '@/components/xhtml/54_Circumstances'
 import XHTML55_WARNING_SIGNS from '@/components/xhtml/55_Warning_Signs'
 import XHTML56_WHAT_TO_DO from '@/components/xhtml/56_What_to_Do'
 import XHTML57_GETTING from '@/components/xhtml/57_Getting'
 import XHTML58_QUICK_GUIDE from '@/components/xhtml/58_Quick_Guide'
 import XHTML59_ORGANIZATIONS from '@/components/xhtml/59_Organizations'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML60_APPENDIX from '@/components/xhtml/60_Appendix'
 import XHTML61_AFTERWORD from '@/components/xhtml/61_Afterword'
 import XHTML62_REFERENCE from '@/components/xhtml/62_Reference'
 import XHTML63_GRATITUDE from '@/components/xhtml/63_Gratitude'
 import XHTML64_ABOUT_THE_AUTHOR from '@/components/xhtml/64_About_the_Author'
 import XHTML65_BM01 from '@/components/xhtml/65_Bm01'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/00_Cover",
 			"name" : "xhtml/00_Cover",
 			"component" : XHTML00_COVER
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/01_Title",
 			"name" : "xhtml/01_Title",
 			"component" : XHTML01_TITLE
 		},
 		{
 			"path" : "/xhtml/02_Dedication",
 			"name" : "xhtml/02_Dedication",
 			"component" : XHTML02_DEDICATION
 		},
 		{
 			"path" : "/xhtml/03_Fm01",
 			"name" : "xhtml/03_Fm01",
 			"component" : XHTML03_FM01
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/04_Foreword",
 			"name" : "xhtml/04_Foreword",
 			"component" : XHTML04_FOREWORD
 		},
 		{
 			"path" : "/xhtml/05_Prologue",
 			"name" : "xhtml/05_Prologue",
 			"component" : XHTML05_PROLOGUE
 		},
 		{
 			"path" : "/xhtml/06_Part01",
 			"name" : "xhtml/06_Part01",
 			"component" : XHTML06_PART01
 		},
 		{
 			"path" : "/xhtml/07_Chapter01",
 			"name" : "xhtml/07_Chapter01",
 			"component" : XHTML07_CHAPTER01
 		},
 		{
 			"path" : "/xhtml/08_Chapter02",
 			"name" : "xhtml/08_Chapter02",
 			"component" : XHTML08_CHAPTER02
 		},
 		{
 			"path" : "/xhtml/09_Chapter03",
 			"name" : "xhtml/09_Chapter03",
 			"component" : XHTML09_CHAPTER03
 		},
 		{
 			"path" : "/xhtml/10_Chapter04",
 			"name" : "xhtml/10_Chapter04",
 			"component" : XHTML10_CHAPTER04
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js